import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';

export default function TermsOfService() {
  return (
    <div className="min-h-screen" data-testid="terms-page">
      <div className="border-b border-[#09090B] py-8">
        <div className="container-swiss">
          <p className="mono-data text-[#09090B] mb-1">Legal</p>
          <h1 className="text-3xl md:text-4xl font-black tracking-tighter flex items-center gap-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
            <FileText className="w-8 h-8 text-[#09090B]" />
            Terms of Service
          </h1>
          <p className="mono-data text-xs text-zinc-500 mt-2">Last updated: April 30, 2026</p>
        </div>
      </div>

      <div className="container-swiss py-8 max-w-3xl">
        <div className="space-y-6 text-sm leading-relaxed text-zinc-700">
          <section>
            <h2 className="text-lg font-bold mt-0 mb-3 text-black">1. Agreement</h2>
            <p>
              By using FOKYES (the "Platform"), operated by <strong>FOKYES</strong>,
              you agree to these Terms. If you're under 18, your parent or legal guardian must consent on your behalf.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 text-black">2. Cognitive Training — Important Disclaimer</h2>
            <div className="border-l-4 border-[#09090B] bg-zinc-100 px-4 py-3">
              <p className="font-semibold">
                The Platform and its "BrainMap Score" are <strong>educational tools</strong>, not medical or
                diagnostic devices. The Platform does not diagnose, treat, cure, or prevent any medical,
                neurological, or psychological condition including ADHD, dyslexia, autism, anxiety, or learning disabilities.
              </p>
            </div>
            <p className="mt-3">
              If you have concerns about cognitive health, consult a qualified medical professional.
              BrainMap scores reflect task performance on the Platform only and are not clinical assessments.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 text-black">3. Account & Eligibility</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Minimum age: 6 years</li>
              <li>Users under 18 require verifiable parental consent</li>
              <li>Accurate date of birth is required</li>
              <li>One account per person</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 text-black">4. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>Cheat, automate, or manipulate session results</li>
              <li>Upload malicious content via the Creator Marketplace</li>
              <li>Link to a child account without being their legal parent/guardian</li>
              <li>Scrape or redistribute proprietary content</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 text-black">5. Subscriptions & Payments</h2>
            <p>
              Paid subscriptions (Pro, Enterprise) renew automatically until cancelled.
              Prices are listed on the <Link to="/pricing" className="text-[#09090B] underline">Pricing</Link> page.
              Refunds: pro-rata within 7 days of first charge if no content has been consumed.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 text-black">6. Creator Marketplace</h2>
            <p>
              Creators publish programs and receive 70% of net revenue (platform retains 30%).
              Creators warrant that content is original and non-infringing. FOKYES may
              remove content that violates these Terms or applicable law.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 text-black">7. Intellectual Property</h2>
            <p>
              The Platform, BrainMap methodology, and all original content are owned by FOKYES.
              Creator-contributed content is owned by the creator, licensed to us for distribution.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 text-black">8. Termination</h2>
            <p>
              You may delete your account anytime from Settings. We may suspend or terminate accounts
              that violate these Terms, with notice where practical.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 text-black">9. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, FOKYES is not liable for indirect,
              incidental, or consequential damages. Total liability is capped at fees paid in the
              preceding 12 months.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 text-black">10. Governing Law & Disputes</h2>
            <p>
              These Terms are governed by the laws of India. Disputes will be resolved in the courts of
              Bengaluru, India, unless mandatory consumer-protection laws in your country require otherwise.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 text-black">11. Changes</h2>
            <p>
              We may update these Terms. Material changes will be notified by email or in-app at least 14 days before taking effect.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold mb-3 text-black">12. Contact</h2>
            <p>
              fokyes.com — <a href="mailto:legal@storytellercharles.com" className="text-[#09090B] underline">legal@storytellercharles.com</a>
            </p>
          </section>

          <section className="pt-4 border-t border-zinc-200">
            <p className="text-xs text-zinc-500">
              See also: <Link to="/privacy" className="text-[#09090B] underline">Privacy Policy</Link>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
